import React from "react";
import { Photo } from "../data/photography";
type EditorialImageProps = {
  image: Photo;
  aspect?: string;
  caption?: string;
  className?: string;
  priority?: boolean;
};
export function EditorialImage({
  image,
  aspect = "aspect-[4/5]",
  caption,
  className = "",
  priority = false
}: EditorialImageProps) {
  return <figure className={className} data-id="element-94" data-mp="1c9tgmgwca5nw">
      <div className={`overflow-hidden bg-stone ${aspect}`} data-id="element-95" data-mp="1qb5v0nvupz7o">
        <img src={image.src} alt={image.alt} loading={priority ? "eager" : "lazy"} className="h-full w-full object-cover" data-id="element-96" data-mp="1q9l212p6qobx" />
      </div>
      {caption && <figcaption className="mt-4 flex gap-3 text-xs leading-relaxed tracking-[0.04em] text-charcoal/70" data-id="element-97" data-mp="2005vyctwz4oi">
          <span aria-hidden className="mt-[7px] block h-px w-6 shrink-0 bg-oxblood" data-id="element-98" data-mp="1v3z05cv8f9ka" />
          {caption}
        </figcaption>}
    </figure>;
}